(function (w, $) {

    const assetId = '~/Parts/Views/Site/ScrollToTop.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {

        const $scrollToTop = $("#" + ctx.containerID);
        const scrollToTopDisabled = "scroll-to-top_disabled";
        const animationDuration = $scrollToTop.data("animation-duration") || 300;
        const yOffset = $scrollToTop.data("y-offset") || 300;

        checkState();

        $scrollToTop.on("click",
            function() {
                $("body").scrollToThis(animationDuration);
            });

        $(w).on("scroll",
            function() {
                if (w.requestAnimationFrame) {
                    w.requestAnimationFrame(checkState);
                } else {
                    checkState();
                }
            });

        function checkState() {
            if (w.pageYOffset > yOffset) {
                if ($scrollToTop.hasClass(scrollToTopDisabled)) {
                    $scrollToTop.removeClass(scrollToTopDisabled);
                }
            } else {
                if (!$scrollToTop.hasClass(scrollToTopDisabled)) {
                    $scrollToTop.addClass(scrollToTopDisabled);
                }
            }
        }
    }
})(window, jQuery);